import { useCallback, FC } from 'react';
import { useDispatch } from 'react-redux';

import { templateActions } from '../../../store/modules/template';

import { SliderItem } from './Wrapper';

type SlideProps = {
  preview: string;
  isActive: boolean;
  templateId: string;
};

const Slide: FC<SlideProps> = ({ templateId, isActive, preview }) => {
  const dispatch = useDispatch();

  const handleSlideClick = useCallback(
    () =>
      dispatch(
        templateActions.fetchTemplateView({
          templateIdOrSlug: templateId
        })
      ),
    [templateId]
  );

  return (
    <SliderItem {...{ isActive }} onClick={handleSlideClick}>
      <img src={preview} alt={preview} />
    </SliderItem>
  );
};

export default Slide;
